<app-exam-header [pageTitle]="'Library'"></app-exam-header>
<section class="hero-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <!-- Tabs removed -->

        <!-- Book cover and description (kept) -->
        <div class="row mx-0 mt-4 book-hero-content">
          <div
            class="col-lg-2 col-md-3 col-sm-4 col-6 mb-3 mb-md-0 text-center mx-auto mx-sm-0"
          >
            <!-- Image placeholder -->
            <div class="image-placeholder">
              <img
                [src]="siteUrl + 'api/static/' + bookCover"
                class="img-fluid cover-image"
                alt="Book Cover"
              />
            </div>
          </div>
          <div class="col-lg-10 col-md-9 col-sm-8 col-12">
            <!-- Description content -->
            <div class="book-description">
              <h2
                class="mb-3 responsive-heading"
                style="
                  font-family: 'Poppins' !important;
                  font-weight: 900;
                "
              >
                {{ books[0]?.name }}
              </h2>
              <div class="context-container">
                <p
                  class="lead book-context"
                  style="font-style: italic;"
                >
                  {{ books[0]?.caption }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Content viewer (outside hero) -->
<section
  class="viewer-section"
  style="background-color: #0e0000; margin-top: 0; padding-top: 0"
>
  <div class="container">
    <!-- Videos Section -->
    <div class="row px-3">
      <div class="col-12">
        <div class="section-header" style="padding-top: 2rem;">
          <h3 class="section-title">Videos</h3>
          <div class="section-divider"></div>
        </div>
      </div>
      <div
        class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4"
        *ngFor="let ytVideo of videoUrls; let i = index"
      >
        <div
          class="video-card enhanced youtube-card"
          (click)="openYoutubePopup(ytVideo)"
        >
          <div class="video-thumbnail">
            <div class="thumbnail-placeholder">
              <img
                [src]="ytVideo.thumbnail_url"
                alt="YouTube Thumbnail"
                class="youtube-thumbnail"
              />
              <div class="play-button-overlay">
                <i class="fab fa-youtube"></i>
              </div>
            </div>
            <div class="video-info">
              <h5 class="video-title">{{ ytVideo.title }}</h5>
              <p class="video-description">{{ ytVideo.chapterName }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Video Popup Modal -->
<div
  class="video-popup-overlay"
  *ngIf="showVideoPopup"
  (click)="closeVideoPopup()"
>
  <div class="video-popup-container" (click)="$event.stopPropagation()">
    <div class="video-popup-header">
      <h4 *ngIf="selectedVideo">{{ getFileName(selectedVideo.value) }}</h4>
      <button class="close-button" (click)="closeVideoPopup()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="video-popup-body">
      <video *ngIf="selectedVideo" controls autoplay class="popup-video-player">
        <source
          [src]="siteUrl + 'api/static/' + selectedVideo.value"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="video-popup-footer" *ngIf="selectedVideo">
      <p class="chapter-name">From: {{ selectedVideo.chapterName }}</p>
    </div>
  </div>
</div>

<!-- YouTube Video Popup Modal -->
<div
  class="video-popup-overlay"
  *ngIf="showYoutubePopup"
  (click)="closeYoutubePopup()"
>
  <div class="video-popup-container" (click)="$event.stopPropagation()">
    <div class="video-popup-header">
      <h4 *ngIf="selectedYoutubeVideo">{{ selectedYoutubeVideo.title }}</h4>
      <button class="close-button" (click)="closeYoutubePopup()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="video-popup-body">
      <iframe
        *ngIf="selectedYoutubeVideo"
        width="100%"
        height="500"
        [src]="getSafeYoutubeUrl(selectedYoutubeVideo.youtubeUrl)"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      >
      </iframe>
    </div>
    <div class="video-popup-footer" *ngIf="selectedYoutubeVideo">
      <p class="video-description">{{ selectedYoutubeVideo.description }}</p>
    </div>
  </div>
</div>

<section class="audio-section py-5" *ngIf="audios.length">
  <div class="container">
    <div class="section-header mb-4">
      <h3 class="section-title">Audio Library</h3>
      <div class="section-divider"></div>
    </div>

    <div class="audio-grid">
      <div
        class="minimal-audio-card"
        *ngFor="let audio of audios; let i = index"
      >
        <div class="audio-header">
          <h5 class="audio-title">{{ getFileName(audio.value) }}</h5>
        </div>

        <div class="audio-content">
          <p class="audio-chapter">{{ audio.chapterName }}</p>

          <audio
            #audioPlayer
            class="d-none"
            [src]="siteUrl + 'api/static/' + audio.value"
            preload="metadata"
            (timeupdate)="
              updateProgress(
                audioPlayer,
                progressBar,
                currentTimeEl,
                durationEl
              )
            "
            (loadedmetadata)="onAudioLoaded(audioPlayer, durationEl)"
          ></audio>

          <div class="wave-container">
            <span></span><span></span><span></span><span></span><span></span>
            <span></span><span></span><span></span><span></span><span></span>
          </div>

          <div class="minimal-player">
            <button class="play-button" (click)="toggleAudio(audioPlayer)">
              <i
                [class]="
                  isPlaying(audioPlayer) ? 'fas fa-pause' : 'fas fa-play'
                "
              ></i>
            </button>

            <div class="progress-container">
              <div class="time current" #currentTimeEl>0:00</div>
              <div
                class="progress-track"
                (click)="seekAudio($event, audioPlayer, progressBar)"
              >
                <div class="progress-bar" #progressBar></div>
              </div>
              <div class="time total" #durationEl>0:00</div>
            </div>

            <div class="volume-button" (click)="toggleMute(audioPlayer)">
              <i class="fas fa-volume-up"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Space-themed card section (after audio section) -->
<section class="space-card-section">
  <div class="container">
    <div class="space-card">
      <div class="stars-bg">
        <!-- Generated stars will be added here by JavaScript -->
      </div>
      <div class="space-card-content">
        <h2 class="space-title">The Final Spark</h2>
        <p class="space-description">
          Your journey through knowledge doesn't end here. Consider this your
          final spark—a reminder that even more exciting insights await. Click
          below to redirect to a universe of additional content, where you'll
          discover the finishing spark that will illuminate your understanding
          completely.
        </p>
        <a href="/more-info" class="space-button">
          <span class="space-icon"><i class="fas fa-rocket"></i></span>
          Dive In & Know More
        </a>
      </div>
    </div>
  </div>
</section>

<app-exam-footer></app-exam-footer>
